<template>
  <div class="sys-user">
    <Tree @onSelect="treeSelect" ref="tree" :deptId="deptId"></Tree>
    <div class="sys-table">
      <ToolBar
      :showAdd="showAdd"
      :toolsArr="toolsArr"
      :searchArr="fields"
      :showExp="showExp"
      :url="url"
      :type="type"
      @search="search"
      @filter="filterFields"
      @add="add"
      @dropMenuClick="dropMenuClick"
      @export="exportClick"
      @upload="uploadClick"
      :placeholder="placeholder"
      ></ToolBar>
      <div class="table-content">
          <Table
            ref="table"
            :options="fields"
            :tableValue="tableValue"
            :customSlotOpt="slotOpt"
            :otherOpt="customOtherOpt"
            @change="initTableValue"
            @actionClick="handlerActionClick"
            @selectRow="handlerSelect"
            :scroll="{ x: 1300, y: `calc(100vh - ${300 + 'px'})` }"
        ></Table>
      </div>
      <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
      <Modal :id="id" :deptId="deptId" :readonly="readonly" :visible="visible" @ok="handleClickOk" @cancel="handleClickOk"></Modal>
      <UploadModal
      :url="url"
      :type="type"
      :deptId="deptId"
      :visible="upload"
      @ok="uploadOk"
      @cancel="uploadCancel"
      @upload="uploadClick"
      >
      </UploadModal>
    </div>
  </div>
</template>

<script>
const baseUrl = process.env.VUE_APP_BASE_URL
//import { cloneDeep } from 'lodash'
//passReject
import {getDeptData, exportUser, deleteUser, passReject, changeUserStatus, getUserInfoByTerms} from '@/api/back.js'
import {toolsArr, fields, slotOpt} from './config'
import mixinsBackStack from '@/views/Back/mixins'
import Tree from '../../components/treeSelect/tree.vue'
import ToolBar from '../../components/toolBar/index.vue'
import Table from '@/views/Back/components/table/index.vue'
import AModal from '@/views/Back/components/AModal'
import Modal from './modal.vue'
import UploadModal from './uploadModal.vue'
export default {
  mixins: [mixinsBackStack],
  components: {
      Tree,
      ToolBar,
      Table,
      AModal,
      Modal,
      UploadModal
  },
  data() {
      return {
          id: null,
          readonly: false,
          visible: false,
          showAdd: true,
          showExp: false,
          upload: false,
          toolsArr,
          fields,
          slotOpt,
          deptId: null, //默认选择的部门树
          inquireValue: '', //条件搜索
          customOtherOpt: {
            pagination: {
            total: 0,
            pageNum: 1,
            pageSize: 10
            }
        },
          tableValue: [],
          url: baseUrl + '/system/user/batch_import',
          type: ['xlsx'],
          placeholder: '输入ID、名称或角色搜索'
      }
  },
  created() {
    //this.initTableValue()
  },
  methods: {
      handleClickOk() {
          this.visible = false
          this.readonly = false
          this.id = null
          this.initTableValue()
      },
      async initTableValue() {
        try {
          this.loadingTable(true) // 开启表格的加载动画
          const params = this.handlerBeforeRequestParams()
          const { rows, total } = this.inquireValue ? await getUserInfoByTerms({...params, inquireValue: this.inquireValue}) : await getDeptData(params) // 请求表格数据接口
          const row = this.handlerDateFormat(rows) // 处理时间格式
          this.handlerResultMappings(rows) // 处理数据的映射关系
          rows.forEach(item => {
            item.deptName = item.dept?.deptName
            item.roleName = ''
            item.roles.forEach(ele => {
              if (ele.roleName) {
                item.roleName += ele.roleName + ' '
              }
            })
          })
          this.tableValue = row
          this.customOtherOpt.pagination.total = total
          this.initSelectedRowIds() // 清空勾选的选项
        } catch (error) {
          console.log('error', error)
          this.$apiStatusHandler(99, error.msg) // 请求异常，则全局轻提示
        } finally {
          this.loadingTable(false)
        }
    },

    // 请求前的参数收集
    handlerBeforeRequestParams(searchParam) {
      const { pagination } = this.$refs.table
      const { pageSize, pageNum } = pagination
      const params = {
        ...searchParam,
        deptId: this.deptId,
        pageNum,
        pageSize
      }
      return params
    },
    //树选择
    treeSelect(v) {
        this.deptId = v[0]
        this.initTableValue()
    },
    //左边下拉选择
    async dropMenuClick(key) {
        console.log(key)
        const tableRef = this.$refs.table
        const selectedIds = tableRef.selectedRowIds
        console.log('selectedIds',selectedIds)
        //const idstatus = selectedIds.map(item => item.id)
        if (selectedIds.length === 0 && key !== '1') {
          return this.$apiStatusHandler(999, '您还未选中需要操作的数据')
        }
        switch (key) {
          case '1': 
            this.upload = true
            break;
          case '2':
            //通过
            this.passReject({ids: selectedIds, useStatus: 0})
            break;
          case '3':
            //驳回
            this.passReject({ids: selectedIds, useStatus: 2})
            break;
          default:
            break;
        }
    },
    uploadOk() {
      this.upload = false
    },
    uploadCancel() {
      this.upload = false
    },
    //处理子组件返回的参数
    search(v) {
      if (v) {
        this.inquireValue = v
      } else {
        this.inquireValue = ''
      }
      this.initTableValue()
    },
    //过滤表格字段
    filterFields({v, i}) {
      this.$set(this.fields[i], "isShow", v)  
    },
    add() {
        this.visible = true
    },
    edit(row) {
        this.visible = true
        this.id = +row.id
    },
    detail(row) {
        this.visible = true
        this.id = +row.id
        this.readonly = true
    },
    //驳回
    rejected(row) {
        this.customModalOpt.contentTips = '是否确定驳回该内容'
        this.beforeShowModal(true, {
            source: 'passReject',
            params: { ids: [row.id], useStatus: 2 }
        })
    },
    //通过
    passed(row) {
        this.customModalOpt.contentTips = '是否确定通过该内容'
        this.beforeShowModal(true, {
            source: 'passReject',
            params: { ids: [row.id], useStatus: 0 }
        })
    },
    //驳回通过
    async passReject(params) {
      try {
        const { msg, code } = await passReject(params)
        //this.initTableValue()
        this.$refs.tree.getDeptData()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    //状态修改
    async changeStatus(params) {
      try {
        const { msg, code } = await changeUserStatus(params)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    //正常变禁止
    normal(row) {
      console.log('row',row)
      this.changeStatus({ids: [row.id], useStatus: 1})
    },
    //禁止变正常
    banned(row) {
      this.changeStatus({ids: [row.id], useStatus: 0})
    },
    // 单独删除
    singleDelete(row) {
      this.customModalOpt.contentTips = '是否确定删除该内容'
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: row.id }
      })
    },
    // 批量删除
    batchDelete() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      const idstatus = selectedIds.map(item => item.id)
      if (selectedIds.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的数据')
      }
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: idstatus }
      })
    },
    // 调用删除接口
    async dealDeleteApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await deleteUser(ids)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    //导入
    async uploadClick(e) {
      const { code, msg } = e
      if (code === 200) {
        this.initTableValue()
        this.$message.success(msg)
      } else {
        this.$message.warning(msg)
      }
    },
    //导出
    async exportClick() {
      const tableRef = this.$refs.table
      const selectedIds = tableRef.selectedRowIds
      //const idstatus = selectedIds.map(item => item.id)
      // const {code, msg} = await exportUser({ids: selectedIds})
      // if (code === 200) {
      //   this.downloadFile('用户数据', msg);
      //   this.$apiStatusHandler(200, '导出成功');
      // }
      const data = await exportUser({ids: selectedIds})
      const blob = new Blob([data])
      const elink = document.createElement('a')
      elink.download = `导出用户信息.xlsx`
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    },
    // 下载文件
    downloadFile (name, url) {
      const a = document.createElement('a');
      a.setAttribute('download', name);
      a.setAttribute('href', url);
      a.click();
      document.body.removeChild(a)
    },
    //选择的数据
    handlerSelect(v) {
      if (v.length) {
          this.showExp = true
      } else {
          this.showExp = false
      }
    },
  }
}
</script>

<style>

</style>